import MediaQuery from 'react-responsive';
import matchMedia from 'matchmediaquery';
import React from 'react';

export const Desktop = (props) => <MediaQuery {...props} minWidth={992} />;
export const Mobile = (props) => <MediaQuery {...props} maxWidth={768} />;
export const Default = (props) => <MediaQuery {...props} minWidth={769} />;

export const isMobile = () =>
  matchMedia('only screen and (max-width: 768px)').matches;
export const isMobileLandscape = () =>
  matchMedia('only screen and (max-height: 480px) and (orientation: landscape)')
    .matches;

export const isIOS = () => {
  const ua = window.navigator.userAgent;
  const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);

  return iOS;
};

export default {
  Desktop,
  Mobile,
  Default,
};
